import { render, staticRenderFns } from "./MyIntegrations.vue?vue&type=template&id=45e5883b&scoped=true"
import script from "./MyIntegrations.vue?vue&type=script&lang=js"
export * from "./MyIntegrations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45e5883b",
  null
  
)

export default component.exports